import React from 'react';

import { Tag } from '@rikstv/shared-components';

import { Link } from '../../router';

import { ReactComponent as ImdbIcon } from './imdb.svg';

import styles from './ImdbBadge.module.css';

interface Props {
  imdbRating: string | undefined;
  imdbId?: string;
}

const ImdbBadge: React.FunctionComponent<Props> = ({ imdbRating, imdbId }) => {
  if (!imdbRating) {
    return null;
  }

  const content = (
    <>
      <ImdbIcon className={styles.imdbBadgeSvg} aria-hidden />
      <Tag>
        {imdbRating}
        <span className="sr-only">i vurdering på IMDb.</span>
      </Tag>
    </>
  );

  if (!!imdbId) {
    return (
      <Link
        className={styles.link}
        to={`https://www.imdb.com/title/${imdbId}/`}
        target="_blank"
        rel="noopener noreferrer">
        {content}
      </Link>
    );
  }

  return content;
};

export { ImdbBadge };
